import React from 'react';
import { T } from '@testout/labsim-ui-atomics';
export var IntermediateCheckboxState;
(function (IntermediateCheckboxState) {
    IntermediateCheckboxState["CHECKED"] = "CHECKED";
    IntermediateCheckboxState["PARTIAL"] = "PARTIAL";
    IntermediateCheckboxState["UNCHECKED"] = "UNCHECKED";
})(IntermediateCheckboxState || (IntermediateCheckboxState = {}));
/***
 * Intermediate (or Indeterminate) checkbox state can only be managed and set using JavaScript and
 * may appear differently on each browser
 */
export default class IntermediateCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.onChange = () => {
            let newCheckedState;
            if (this.state.checkedState === IntermediateCheckboxState.UNCHECKED ||
                this.state.checkedState === IntermediateCheckboxState.PARTIAL) {
                newCheckedState = IntermediateCheckboxState.CHECKED;
            }
            else {
                newCheckedState = IntermediateCheckboxState.UNCHECKED;
            }
            this.setState({ checkedState: newCheckedState }, () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.checkedState);
                }
            });
        };
        this.state = {
            checkedState: props.checkedState || IntermediateCheckboxState.UNCHECKED,
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.checkedState !== nextProps.checkedState ||
            this.state.checkedState !== nextProps.checkedState) {
            this.setState({ checkedState: nextProps.checkedState }, () => {
                if (this.inputRef.current) {
                    if (this.state.checkedState === IntermediateCheckboxState.PARTIAL)
                        this.inputRef.current.indeterminate = true;
                    else
                        this.inputRef.current.indeterminate = false;
                }
            });
        }
        return true;
    }
    render() {
        return (React.createElement(T.Input.Checkbox, { className: this.props.className, ref: this.inputRef, checked: this.state.checkedState === IntermediateCheckboxState.CHECKED, indeterminate: this.state.checkedState === IntermediateCheckboxState.PARTIAL, onChange: this.onChange, disabled: this.props.disabled, name: this.props.name, automationId: this.props.name }, this.props.children));
    }
}
//# sourceMappingURL=IntermediateCheckbox.js.map